import type {FC, ComponentType} from 'react';
import {useNavigate, useLocation} from 'react-router-dom';
import {
  Box,
  Button,
  Icon,
  IconNames,
  Stack,
  Typography,
} from '@wellstone-solutions/web';

interface BackButtonProps {
  label: string;
  path: string;
}

interface Location {
  state?: {
    backButtonProps?: BackButtonProps;
  };
}

interface PageHeaderProps {
  ActionButton?: ComponentType<object>;
  backButtonProps?: BackButtonProps;
  description?: string;
  hideDescriptionOnMobile?: boolean;
  title: string;
}

export const PageHeader: FC<PageHeaderProps> = ({
  ActionButton,
  backButtonProps,
  description,
  hideDescriptionOnMobile = true,
  title,
}) => {
  const navigate = useNavigate();
  const location = useLocation() as Location;

  const finalBackButtonProps =
    backButtonProps || location.state?.backButtonProps;

  return (
    <Box>
      {finalBackButtonProps && (
        <Button
          sx={styles.backButton}
          onClick={() => navigate(finalBackButtonProps.path)}
          startIcon={<Icon name={IconNames.ArrowLeft} size={16} />}>
          {finalBackButtonProps.label}
        </Button>
      )}

      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="top"
        sx={{mb: 4}}>
        <Box>
          <Typography variant="h4" component="h1" sx={styles.title}>
            {title}
          </Typography>
          {description && (
            <Typography
              variant="body"
              sx={hideDescriptionOnMobile && styles.mobileDesc}>
              {description}
            </Typography>
          )}
        </Box>

        {!!ActionButton && (
          <Box>
            <ActionButton />
          </Box>
        )}
      </Stack>
    </Box>
  );
};

const styles = {
  title: {
    fontSize: '32px',
    lineHeight: '42px',
    fontWeight: {
      xs: '500',
      sm: '700',
    },
    color: 'onSurface.main',
  },
  mobileDesc: {
    display: {xs: 'none', md: 'block'},
  },
  backButton: {
    color: 'link.main',
    ml: 1,
    mb: 2,
    textTransform: 'none',
  },
};
